// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__FudpZ","tab_active":"Tab_tab_active__jQzHr"};